import { test } from './modules/test';
test();
